import { Breadcrumb, Button, Col, Form, Row, Steps } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAPIPublic, useDealer } from "../../../../../tools/api";
import { fileToformData, getFieldDocument, regexFormater, validateInput } from "../../../../../tools/tools";
import { _adr } from "../../../../../address";
import { simcardPurchase } from "../../../../../reducer/serviceReducer";
import Loading from "../../../../auxiliary/loader/loading";
import ResizeImage from "../../../../auxiliary/resizeImg/resizeImage";
import { Content } from "antd/es/layout/layout";
import { HomeOutlined } from "@ant-design/icons";
import CWLayout from "../../../../changeOwnership/change/cwLayout";
import Profile from "../../profile/profile";

const CowUpload = () => {
	const [t] = useTranslation("global");
	const { addDocument } = useAPIPublic();
	const { addProfile, addAddress, updateDocumentProfile } = useDealer();
	const formData = useSelector((state) => state?.from?.coownership);
	const dispatch = useDispatch();
	const nav = useNavigate();

	const [frmDocument] = Form.useForm();
	const [upd, setUpd] = useState({
		isLoading: false,
		purchase: formData.purchase,
	});

	const handleSubmit = async (values) => {
		try {
			setUpd((up) => ({ ...up, isLoading: true }));

			let resBuyerDocument = await addDocument(await fileToformData(values.documentBuyer), getFieldDocument(formData?.profile?.certtype));
			if (resBuyerDocument) {
				let payload = {
					fname: formData?.profile?.isLangPersian ? formData?.profile?.fname : undefined,
					lname: formData?.profile?.isLangPersian ? formData?.profile?.lname : undefined,
					fathername: formData?.profile?.isLangPersian ? formData?.profile?.fathername : undefined,
					identityno: formData?.profile?.identityno,
					certno: formData?.profile?.certno,
					certtype: formData?.profile?.certtype,
					birthdate: formData?.profile?.birthdate.replace(/\//g, "-"),
					gender: formData?.profile?.gender,
					smsmobileno: regexFormater(formData?.profile?.smsmobileno).removeSpace(),
					profiletype: 23,
					nationality: "",
					enfname: !formData?.profile?.isLangPersian ? formData?.profile?.fname : undefined,
					enlname: !formData?.profile?.isLangPersian ? formData?.profile?.lname : undefined,
					enfathername: !formData?.profile?.isLangPersian ? formData?.profile?.fathername : undefined,
					countryid: !formData?.profile?.isLangPersian ? formData?.profile?.countryid : undefined,
					documentid: resBuyerDocument.Result,
				};
				let responseProfile = await addProfile(payload);
				if (responseProfile) {
					payload = {
						profileid: responseProfile.profileId,
						addresstype: 0,
						addressmodel: {
							cityid: formData?.profile?.cityid,
							mainstreet: formData?.profile?.mainstreet,
							auxiliaryroad: formData?.profile?.auxiliaryroad,
							alley: formData?.profile?.alley,
							buildingno: formData?.profile?.buildingno,
							floor: formData?.profile?.floor,
							postalcode: formData?.profile?.postalcode,
							tel: formData?.profile?.tel,
							unit: formData?.profile?.unit,
						},
					};

					let responseAddress = await addAddress(payload);
					if (responseAddress && !responseAddress.HasError) {
						payload.addresstype = 1;
						let resAgainAddress = await addAddress(payload);
						if (resAgainAddress && !resAgainAddress.HasError) {
							dispatch(
								simcardPurchase({
									coownership: {
										...formData,
										profile: {
											...formData?.profile,
											profileid: responseProfile.profileId,
											documentid: resBuyerDocument.Result,
											photo: values.documentBuyer,
										},
									},
								}),
							);
							nav(_adr.Root + _adr.Corporate.Index + _adr.Corporate.Ownership.Index + _adr.Corporate.Ownership.Review);
						}
					}
				}
			}

			setUpd((up) => ({ ...up, isLoading: false }));
		} catch (error) {
			console.error(error);
			setUpd((up) => ({ ...up, isLoading: false }));
		}
	};
	const handleGetImageSeller = async (value) => {
		frmDocument.setFieldValue("documentSeller", value);
	};
	const handleGetImageBuyer = async (value) => {
		frmDocument.setFieldValue("documentBuyer", value);
	};
	return (
		<>
			<CWLayout>
				<div className="holder-top-of-page-content">
					<div className="g-hold-title-of-page">
						<Breadcrumb
							className="breadcrumbs"
							items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("changeOwnerShip.ownership.title") }]}
						/>
						<div className="title-page">
							<h3>{t("changeOwnerShip.ownership.title")}</h3>
							<p></p>
						</div>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main da-container">
						<div className="g-format-page">
							<Profile Profile={upd.purchase} state />
							<br />
							<div className="g-body-format-page">
								<div className="g-format-steps">
									<div className="holder-step">
										<Steps
											size="small"
											className="step-wizard"
											current={1}
											responsive
											items={[
												{
													title: "اطلاعات خریدار(حقیقی)",
												},
												{
													title: "آپلود مدرک شناسایی (حقیقی)",
												},
												{
													title: "بررسی نهایی",
												},
											]}
										/>
									</div>
								</div>
								<div className="cw-swap-document">
									<Form id="frmDocument" form={frmDocument} onFinish={handleSubmit} layout="vertical">
										<Row gutter={30}>
											<Col xs={24} sm={12} md={12} lg={12} xl={8}>
												<Form.Item
													className="input-normal"
													name="documentBuyer"
													rules={[validateInput({ t: t, validate: true })]}
													label="تصویر مدرک شناسایی خریدار  ">
													<ResizeImage exportImage={handleGetImageBuyer} />
												</Form.Item>
											</Col>
										</Row>
									</Form>
								</div>
							</div>
							<div className="g-footer-format-page">
								<div className="holder-button">
									<Button form="frmDocument" key="submit" htmlType="submit" className="btn-normal btn-aptel">
										ادامه
									</Button>
									<Button
										onClick={() => nav(_adr.Root + _adr.Corporate.Index + _adr.Corporate.Ownership.Index + _adr.Corporate.Ownership.Profile)}
										className="btn-normal">
										بازگشت
									</Button>
								</div>
							</div>
						</div>
					</Content>
				</div>
				<Loading isOpen={upd.isLoading} text="لطفا چند لحظه منتظر بمانید" />
			</CWLayout>
		</>
	);
};

export default CowUpload;
